// extracted by mini-css-extract-plugin
export default {"taxFeeContainer":"PPOq17","price":"y0JXbv"};